import React from 'react'
import { ArrowRightIcon } from '@heroicons/react/outline';

export default function CardButton(props) {
    const {label,onClick}= props;
  return (
    <button
      onClick={onClick}
      type="button"
      className="flex items-center px-5 py-4 font-bold border group hover:bg-cardFeaturesHover hover:text-primary hover:border-primary xl:px-10 rounded-2xl border-cardText text-cardText"
    >
      <ArrowRightIcon className="order-2 h-5 ml-3 w-7 text-cardText group-hover:text-primary" />
      {label}
    </button>
  );
}
